import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { currencyFormatter, percentFormatter } from "../../../utils/formatters";
import { TextField } from "../../../components/TextField";
import { Score } from "../../../components/Score";
import { BarScore } from "../../../components/BarScore";
import { useTranslation } from "react-i18next";
import { Divider } from "primereact/divider";
 
 
export const InstituicaoPagamento = (data: any) => {
  const { t } = useTranslation();
  const report = data?.result ?? null;
  const getValue = (value?: string): string => value || "Não informado";
  const registros: any[] | undefined = [];
  const vencidos: any[] | undefined = [];
  const modulos: any[] | undefined = [];
  if(report){
    Object.getOwnPropertyNames(report.registros).forEach((registro:any) => {
      const ocorrencia = report.registros[registro];
      const modulo = ocorrencia['DETALHE_MODALIDADES.MODALIDADE'].substring(0,2);
      if(!modulos.includes(modulo)){
        modulos.push(modulo)
      }
 
      const avencer = {
          modalidade: ocorrencia['DETALHE_MODALIDADES.MODALIDADE'],
          vencer30: ocorrencia['DETALHE_MODALIDADES.A_VENCER_1_30'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.A_VENCER_1_30']) : null,
          vencer60: ocorrencia['DETALHE_MODALIDADES.A_VENCER_31_60'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.A_VENCER_31_60']) : null,
          vencer90: ocorrencia['DETALHE_MODALIDADES.A_VENCER_61_90'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.A_VENCER_61_90']) : null,
          vencer180: ocorrencia['DETALHE_MODALIDADES.A_VENCER_91_180'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.A_VENCER_91_180']) : null,
          vencer360: ocorrencia['DETALHE_MODALIDADES.A_VENCER_181_360'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.A_VENCER_181_360']) : null,
          vencerMaisUmAno: ocorrencia['DETALHE_MODALIDADES.A_VENCER_361_9999'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.A_VENCER_361_9999']) : null,
          total: ocorrencia['DETALHE_MODALIDADES.AVENCER'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.AVENCER']) : null,
          limiteCredito: ocorrencia['DETALHE_MODALIDADES.LIMITE_CREDITO'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.LIMITE_CREDITO']) : null
      }
      if(avencer.vencer30 || avencer.vencer60 || avencer.vencer90 || avencer.vencer180 || avencer.vencer360 || avencer.vencerMaisUmAno || avencer.limiteCredito){
        registros.push(avencer);
      }
 
      const vencido = {
        modalidade: ocorrencia['DETALHE_MODALIDADES.MODALIDADE'],
        vencido30: ocorrencia['DETALHE_MODALIDADES.VENCIDO_15_30'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.VENCIDO_15_30']) : null,
        vencido60: ocorrencia['DETALHE_MODALIDADES.VENCIDO_31_60'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.VENCIDO_31_60']) : null,
        vencido90: ocorrencia['DETALHE_MODALIDADES.VENCIDO_61_90'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.VENCIDO_61_90']) : null,
        vencido120: ocorrencia['DETALHE_MODALIDADES.VENCIDO_91_120'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.VENCIDO_91_120']) : null,
        vencido150: ocorrencia['DETALHE_MODALIDADES.VENCIDO_121_150'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.VENCIDO_121_150']) : null,
        vencidoTotal: ocorrencia['DETALHE_MODALIDADES.VENCIDOS'] ? currencyFormatter(ocorrencia['DETALHE_MODALIDADES.VENCIDOS']) : null
      }
 
      if(vencido.vencido30 || vencido.vencido60 || vencido.vencido90 || vencido.vencido120 || vencido.vencido150){
        vencidos.push(vencido);
      }
     
    })
  }
const getModalidade = (codigo:string) => {
  if(codigo === '0101') return    'adiantamentos a depositantes'
  if(codigo === '0201') return    'cheque especial e conta garantida'
  if(codigo === '0202') return    'crédito pessoal - com consignação em folha de pagam.'
  if(codigo === '0203') return    'crédito pessoal - sem consignação em folha de pagam.'
  if(codigo === '0204') return    'crédito rotativo vinculado a cartão de crédito'
  if(codigo === '0205') return    'capital de giro com prazo de vencimento inferior a 30 dias'
  if(codigo === '0206') return    'capital de giro com prazo vencim. igual ou superior 30 dias'
  if(codigo === '0207') return    'vendor'
  if(codigo === '0208') return    'compror'
  if(codigo === '0209') return    'ARO - adiantamento de receitas orçamentárias'
  if(codigo === '0210') return    'cartão de crédito – compra, fatura parcelada ou saque financiado pela instituição emitente do cartão'
  if(codigo === '0211') return    'home equity'
  if(codigo === '0212') return    'microcrédito'
  if(codigo === '0213') return    'cheque especial'
  if(codigo === '0214') return    'conta garantida'
  if(codigo === '0215') return    'capital de giro com prazo de vencimento até 365 dias'
  if(codigo === '0216') return    'capital de giro com prazo vencimento superior 365 dias'
  if(codigo === '0217') return    'capital de giro com teto rotativo'
  if(codigo === '0218') return    'cartão de crédito - não migrado'
  if(codigo === '0250') return    'recebíveis adquiridos'
  if(codigo === '0290') return    'financiamento de projeto'
  if(codigo === '0299') return    'outros empréstimos'
  if(codigo === '0301') return    'desconto de duplicatas'
  if(codigo === '0302') return    'desconto de cheques'
  if(codigo === '0303') return    'antecipação de fatura de cartão de crédito'
  if(codigo === '0398') return    'outros direitos creditórios descontados'
  if(codigo === '0399') return    'outros títulos descontados'
  if(codigo === '0401') return    'aquisição de bens – veículos automotores'
  if(codigo === '0402') return    'aquisição de bens – outros bens'
  if(codigo === '0403') return    'microcrédito'
  if(codigo === '0404') return    'vendor'
  if(codigo === '0405') return    'compror'
  if(codigo === '0406') return    'cartão de crédito – compra ou fatura parcelada pela instituição financeira emitente do cartão'
  if(codigo === '0407') return    'aquisição de bens – veículos automotores acima de 2 toneladas'
  if(codigo === '0440') return    'financiamentos agroindustriais'
  if(codigo === '0450') return    'recebíveis adquiridos'
  if(codigo === '0490') return    'financiamento de projeto'
  if(codigo === '0499') return    'outros financiamentos'
  if(codigo === '0501') return    'financiamento à exportação'
  if(codigo === '0502') return    'adiantamento sobre contratos de câmbio'
  if(codigo === '0503') return    'adiantamento sobre cambiais entregues'
  if(codigo === '0504') return    'crédito decorrentes de contratos de exportação'
  if(codigo === '0590') return    'financiamento de projeto'
  if(codigo === '0599') return    'outros financiamentos à exportação'
  if(codigo === '0601') return    'financiamento à importação'
  if(codigo === '0690') return    'financiamento de projeto'
  if(codigo === '0701') return    'aquisição de bens com interveniência – veículos autom.'
  if(codigo === '0702') return    'aquisição de bens com interveniência – outros bens'
  if(codigo === '0790') return    'financiamento de projeto'
  if(codigo === '0799') return    'outros financiamentos com interveniência'
  if(codigo === '0801') return    'custeio e pré-custeio'
  if(codigo === '0802') return    'investimento e capital de giro de financiam.'
  if(codigo === '0803') return    'comercialização e pré-comercialização'
  if(codigo === '0804') return    'industrialização'
  if(codigo === '0890') return    'financiamento de projeto'
  if(codigo === '0901') return    'financiamento habitacional – SFH'
  if(codigo === '0902') return    'financiamento habitacional – exceto SFH'
  if(codigo === '0903') return    'financiamento imobiliário – empreendim, exceto habitac.'
  if(codigo === '0990') return    'financiamento de projeto'
  if(codigo === '1001') return    'financiamento de TVM'
  if(codigo === '1101') return    'financiamento de infraestrutura e desenvolvimento'
  if(codigo === '1190') return    'financiamento de projeto'
  if(codigo === '1201') return    'arrendamento financeiro exceto veículos automotores e imóveis'
  if(codigo === '1202') return    'arrendamento financeiro imobiliário'
  if(codigo === '1203') return    'subarrendamento'
  if(codigo === '1204') return    'arrendamento operacional'
  if(codigo === '1205') return    'arrendamento financeiro de veículos automotores'
  if(codigo === '1206') return    'arrendamento financeiro de veículos automotores acima de 2 toneladas'
  if(codigo === '1290') return    'financiamento de projeto'
  if(codigo === '1301') return    'avais e fianças honrados'
  if(codigo === '1302') return    'devedores por compra de valores e bens'
  if(codigo === '1303') return    'títulos e créditos a receber'
  if(codigo === '1304') return    'cartão de crédito - compra à vista e parcelado lojista'
  if(codigo === '1350') return    'recebíveis adquiridos'
  if(codigo === '1390') return    'financiamento de projeto'
  if(codigo === '1399') return    'outros com característica de crédito'
  if(codigo === '1401') return    'repasses interfinanceiros'
  if(codigo === '1402') return    'recebíveis de arranjo de pagamento'
  if(codigo === '1403') return    'outros valores a receber relativos a transações de pagamento'
  if(codigo === '1501') return    'beneficiários de garantias prestadas para operações com PJ financeira'
  if(codigo === '1502') return    'beneficiários de garantias prestadas para operações com outras pessoas'
  if(codigo === '1503') return    'beneficiários de garantias prestadas para fundos constitucionais'
  if(codigo === '1504') return    'beneficiários de garantias prestadas para participação em processo licitatório'
  if(codigo === '1505') return    'carta de crédito de importação'
  if(codigo === '1511') return    'coobrigação assumida em cessão com coobrigação para pessoa integrante do SFN'
  if(codigo === '1512') return    'coobrigação assumida em cessão com coobrigação para pessoa não integrante do SFN, inclusive securitizadora e fundos de investimento'
  if(codigo === '1513') return    'beneficiários de outras coobrigações'
  if(codigo === '1590') return    'financiamento de projeto'
  if(codigo === '1599') return    'beneficiários de outras garantias prestadas'
  if(codigo === '1801') return    'CPR - Cédula de Produto Rural'
  if(codigo === '1802') return    'EN - Nota de Exportação'
  if(codigo === '1803') return    'Debêntures'
  if(codigo === '1804') return    'Notas comerciais'
  if(codigo === '1899') return    'outros'
  if(codigo === '1901') return    'limite contratado e não utilizado global'
  if(codigo === '1902') return    'cheque especial'
  if(codigo === '1903') return    'conta garantida'
  if(codigo === '1904') return    'cartão de crédito'
  if(codigo === '1905') return    'capital de giro'
  if(codigo === '1906') return    'crédito pessoal'
  if(codigo === '1907') return    'vendor'
  if(codigo === '1908') return    'compror'
  if(codigo === '1909') return    'descontos'
  if(codigo === '1910') return    'aquisição de bens'
  if(codigo === '1999') return    'outros'
  if(codigo === '2001') return    'retenção de risco assumida por aquisição de cotas de fundos'
  if(codigo === '2002') return    'retenção de risco assumida por aquisição de instrumentos com lastros em operações de crédito'
 
  return codigo;
}
 
const getModulos = (codigo:string) => {
  if(codigo === '01') return    'Adiantamentos a depositantes'
  if(codigo === '02') return    'Empréstimos'
  if(codigo === '03') return    'Direitos creditórios descontados'
  if(codigo === '04') return    'Financiamentos'
  if(codigo === '05') return    'Financiamentos à exportação'
  if(codigo === '06') return    'Financiamentos à importação'
  if(codigo === '07') return    'Financiamentos com interveniência'
  if(codigo === '08') return    'Financiamentos rurais'
  if(codigo === '09') return    'Financiamentos imobiliários'
  if(codigo === '10') return    'Financiamentos de títulos e valores mobiliários'
  if(codigo === '11') return    'Financiamentos de infraestrutura e desenvolvimento'
  if(codigo === '12') return    'Operações de arrendamento'
  if(codigo === '13') return    'Outros créditos'
  if(codigo === '14') return    'Repasses interfinanceiros'
  if(codigo === '15') return    'Coobrigações'
  if(codigo === '18') return    'Títulos de crédito (fora da carteira classificada)'
  if(codigo === '19') return    'Limite'
  if(codigo === '20') return    'Retenção de risco'
 
  return codigo;
}
    
 
  return (
    <div style={{ width: "98%" }}>
      <Panel header="Dado Comportamental de Pagamento">
        
        <Panel header="Dados da Consulta">
          {report.MENSAGEM && (<p><b>Cliente não possui dados no SCR na data-base.</b></p>)}
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Data de Fundação"
                value={getValue(report?.NASCIMENTO_FUNDACAO)}
              />
              <TextField
                label="Data de Início do Relacionamento"
                value={getValue(report?.DT_INICIO_RELACIONAMENTO ? (report?.DT_INICIO_RELACIONAMENTO.substring(8) + '/' + report?.DT_INICIO_RELACIONAMENTO.substring(5,7) + '/' + report?.DT_INICIO_RELACIONAMENTO.substring(0,4)) : report?.DT_INICIO_RELACIONAMENTO )}
              />
              <TextField
                label="Tipo de Documento"
                value={getValue(report?.TIPO_CLIENTE) === '1' ? 'PF' : (getValue(report?.TIPO_CLIENTE) === '2' ? 'PJ' : getValue(report?.TIPO_CLIENTE))}
              />
              <TextField
                label="Total carteira crédito"
                value={currencyFormatter(report?.TOTAL_CARTEIRA_CREDITO)}
              />
              <TextField
                label="Total à vencer"
                value={currencyFormatter(report?.TOTAL_VENCER)}
              />
              <TextField
                label="Total Prejuízo"
                value={currencyFormatter(report?.TOTAL_PREJUIZO)}
              />
              <TextField
                label="Data Base"
                value={getValue(report?.dataBase ? report?.dataBase.split('-').reverse().join('/') : report?.dataBase)}
              />
            </div>
            <div>
              <TextField
                label="Coobrigação Recebida"
                value={currencyFormatter(report?.OBRIGACAO_RECEBIDA)}
              />
              <TextField
                label="Percentual de Documentos Processados"
                value={percentFormatter(
                  report?.PERCENTUAL_DOC_PROCESSADOS
                )}
              />
              <TextField
                label="Número de Instituições"
                value={getValue(report?.QUANTIDADE_INSTITUICOES)}
              />
              <TextField
                label="Faixa de risco"
                value={getValue(report?.FAIXA_RISCO)}
              />
               <TextField
                label="Total Limite"
                value={currencyFormatter(report?.TOTAL_LIMITE)}
              />
              <TextField
                label="Total Vencidos"
                value={currencyFormatter(report?.TOTAL_VENCIDO)}
              />
              <TextField
                label="Quantidade de Operações"
                value={getValue(report?.QUANTIDADE_OPERACOES)}
              />
            </div>
          </section>
        </Panel>
 
        <br />
       
        {report?.SCORE && (
          <Panel header="Score">
            <div style={{ display: "flex", gap: "40px" }}>
              <div
                className="scrScore"
                
              >
                <Score
                  score={report?.SCORE}
                  range={report?.SCORE}
                />
              </div>
  
              <BarScore
                score={report?.SCORE}
                rangeColor={report?.SCORE}
              />
            </div>
  
            <p style={{ fontWeight: "bold" }}>
              IMPORTANTE:{" "}
              <span style={{ fontWeight: "normal", fontStyle: "italic" }}>
                a decisão de aprovação ou não do crédito é de exclusiva
                responsabilidade do concedente. as informações prestadas pelo
                provedor tem como objevo subsidiar essas decisões e, em hipótese
                alguma devem ser ulizadas como justicativa, pelo concedente do
                crédito, para a tomada da referida decisão.
              </span>
            </p>
          </Panel>
        )}
 
        <br />
        {modulos.map((modulo) => (
          <div>
            <Divider align="left">
                <div className="inline-flex align-items-center">
                    <b>{getModulos(modulo)}</b>
                </div>
            </Divider>
            {modulo === '19' ? (
              <DataTable key={modulo} size="small" value={registros.filter((item)=>item.modalidade.startsWith(modulo))} tableStyle={{ minWidth: '50rem' }}>
                <Column body={(item:any)=>getModalidade(item.modalidade)} header={t('modalidade')}></Column>
                <Column field="limiteCredito" header={t('limiteCredito')}></Column>
              </DataTable>
            ) :
            (
              <div>
                {registros.filter((item)=>item.modalidade.startsWith(modulo)).length !== 0 && (
                  <DataTable header="A vencer" key={modulo} size="small" value={registros.filter((item)=>item.modalidade.startsWith(modulo))} tableStyle={{ minWidth: '50rem' }}>
                    <Column body={(item:any)=>getModalidade(item.modalidade)} header={t('modalidade')}></Column>
                    <Column field="vencer30" header={t('aVencer1_30')}></Column>
                    <Column field="vencer60" header={t('aVencer31_60')}></Column>
                    <Column field="vencer90" header={t('aVencer61_90')}></Column>
                    <Column field="vencer180" header={t('aVencer91_180')}></Column>
                    <Column field="vencer360" header={t('aVencer181_360')}></Column>
                    <Column field="vencerMaisUmAno" header={t('aVencerMaisUmAno')}></Column>
                    <Column field="total" header={t('total')}></Column>
                  </DataTable>
                )}
                <br></br>
                {vencidos.filter((item)=>item.modalidade.startsWith(modulo)).length !== 0 && (
                  <DataTable header="Vencido" key={'vencido_'+ modulo} size="small" value={vencidos.filter((item)=>item.modalidade.startsWith(modulo))} tableStyle={{ minWidth: '50rem' }}>
                    <Column body={(item:any)=>getModalidade(item.modalidade)} header={t('modalidade')}></Column>
                    <Column field="vencido30" header={t('aVencer15_30')}></Column>
                    <Column field="vencido60" header={t('aVencer31_60')}></Column>
                    <Column field="vencido90" header={t('aVencer61_90')}></Column>
                    <Column field="vencido120" header={t('aVencer91_120')}></Column>
                    <Column field="vencido150" header={t('aVencer121_150')}></Column>
                    <Column field="vencidoTotal" header={t('total')}></Column>
                  </DataTable>
                )}
              </div>
            )}
            
            <br></br>
          </div>
        ))}
        
      </Panel>
    </div>
  );
};